import React, { memo } from 'react';
import './Filters/Filters.css';
import MultipleSelect from './MultipleSelect';
import { useSecurityFiltersContext } from './Filters/hooks/useSecurityFiltersContext';

const CityFilter = ({ className = '' }) => {
    const { filters, cities, onFilterChange } = useSecurityFiltersContext();

    return (
        <div className={`filtros-container-dashboards ${className}`}>
            <MultipleSelect
                label="Cidade"
                options={cities}
                onChange={onFilterChange}
                name="cidade"
                className="select-cidade-dashboards"
                defaultValue={filters.cidade}
            />
        </div>
    );
};

export default memo(CityFilter);
